// Vault Stripes videos.
// - "autoplay": loops while on screen (paused off-screen).
// - "hover": desktop plays on hover; touch/no-hover plays while in view.
// All have native controls + a play button that hides while playing.
// Respects each block's Muted setting (autoplay needs muted per browser rules).
(function () {
  var hoverCapable = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function safePlay(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  function observeInView(v) {
    if (!('IntersectionObserver' in window)) { safePlay(v); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) safePlay(e.target);
        else e.target.pause();
      });
    }, { threshold: 0.4 });
    io.observe(v);
  }

  document.querySelectorAll('video[data-vst-video]').forEach(function (v) {
    v.muted = v.getAttribute('data-muted') === '1';
    var mode = v.getAttribute('data-mode') || 'autoplay';
    var media = v.closest('.mm-vst__media');

    // Reflect play state on the container so the play-button overlay shows/hides.
    v.addEventListener('play', function () { if (media) media.classList.add('is-playing'); });
    v.addEventListener('pause', function () { if (media) media.classList.remove('is-playing'); });

    // Big play button: play with sound (viewer explicitly asked for it).
    if (media) {
      var btn = media.querySelector('[data-vst-play]');
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); v.muted = false; safePlay(v); });
    }

    if (mode === 'hover' && hoverCapable) {
      var card = media || v.parentElement;
      card.addEventListener('mouseenter', function () { safePlay(v); });
      card.addEventListener('mouseleave', function () { v.pause(); v.currentTime = 0; });
      return;
    }
    // Autoplay, or hover on a touch device: play while visible, pause off-screen.
    observeInView(v);
  });
})();
